module.exports = __webpack_public_path__ + "static/media/addIconButton.6d2829da.svg";